import { Container } from "./styles";
import reactIcon from "../../assets/react-icon.svg";
import whatsapp from "../../assets/whatsapp.svg";
import linkedin from "../../assets/linkedin.svg";
import instagram from "../../assets/instagram.svg";
import github from "../../assets/github.svg";
import facebook from "../../assets/facebook.svg";

export function Footer() {
  return (
    <Container className="footer">
      <div>
        <p>
          Built with <img src={reactIcon} alt="React" />
        </p>
      </div>
      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/afzaal-urrehman-9b01a7244/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="LinkedIn" />
        </a>
        <a
          href="https://github.com/Afzaalurrehma"
          target="_blank"
          rel="noreferrer"
        >
          <img src={github} alt="GitHub" />
        </a>
        <a
          href="https://www.facebook.com/afzalurrehman0/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebook} alt="Facebook" />
        </a>
        <a
          href="https://www.instagram.com/afzaal_urrehman/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagram} alt="Instagram" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B923208785269&text=Hello+Afzaal+I+found+your+contact+through+portfolio+site.%0A%0A"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
      </div>
    </Container>
  );
}
